/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-empty-pattern */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/button-has-type */
/* eslint-disable object-shorthand */
import React, { useState, useEffect, useCallback } from 'react';
import { ToastContainer } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import { isEmpty } from 'lodash';
import { useUser } from '../../../hooks/user/useUser';
import * as keys from '../../../services/config/Keys';
import { useSubscribe } from '../../../hooks/subscribe/useSubscribe';


const UserAccounts = () => {
  const [{ userPlans, isLoading, user }] = useUser();
  // const [
  //   subscribeForPlanWithFlutterWave,
  //   subscribeForPlanWithSlydePay,
  //   // subscribeForPlanWithTheTeller,
  // ] = useSubscribe();

  const [
    {},
    subscribeForPlanWithFlutterWave,
    subscribeForRecurringPlanWithFlutterWave,
    subscribeForPlanWithPaystack,
    subscribeForRecurringPlanWithPaystack,
  ] = useSubscribe();

  const [load, setLoad] = useState(false);
  const [itemprice, setItemprice] = useState(null);
  const [monthNum, setMonthNum] = useState('1');
  const [currentPlan, setCurrentPlan] = useState({});
  const [autoDebit, setAutoDebit] = useState(true);
  const [paystackPlanCode, setPaystackPlanCode] = useState('');
  const [flutterwavePlanCode, setFlutterwavePlanCode] = useState('');

  const planChange = useCallback(
    (plan) => {
      if (plan.monthly_subscription === '150') {
        if (monthNum === '1') {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_150_PLAN_1_MONTH}`);
          setPaystackPlanCode(`${keys.PAYSTACK_150_PLAN_1_MONTH}`);
        } else if (monthNum === '3') {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_150_PLAN_3_MONTHS}`);
          setPaystackPlanCode(`${keys.PAYSTACK_150_PLAN_3_MONTHS}`);
        } else if (monthNum === '6') {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_150_PLAN_6_MONTHS}`);
          setPaystackPlanCode(`${keys.PAYSTACK_150_PLAN_6_MONTHS}`);
        } else {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_150_PLAN_1_YEAR}`);
          setPaystackPlanCode(`${keys.PAYSTACK_150_PLAN_1_YEAR}`);
        }
      } else if (plan.monthly_subscription === '200') {
        if (monthNum === '1') {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_200_PLAN_1_MONTH}`);
          setPaystackPlanCode(`${keys.PAYSTACK_200_PLAN_1_MONTH}`);
        } else if (monthNum === '3') {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_200_PLAN_3_MONTHS}`);
          setPaystackPlanCode(`${keys.PAYSTACK_200_PLAN_3_MONTHS}`);
        } else if (monthNum === '6') {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_200_PLAN_6_MONTHS}`);
          setPaystackPlanCode(`${keys.PAYSTACK_200_PLAN_6_MONTHS}`);
        } else {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_200_PLAN_1_YEAR}`);
          setPaystackPlanCode(`${keys.PAYSTACK_200_PLAN_1_YEAR}`);
        }
      } else if (plan.monthly_subscription === '250') {
        if (monthNum === '1') {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_250_PLAN_1_MONTH}`);
          setPaystackPlanCode(`${keys.PAYSTACK_250_PLAN_1_MONTH}`);
        } else if (monthNum === '3') {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_250_PLAN_3_MONTHS}`);
          setPaystackPlanCode(`${keys.PAYSTACK_250_PLAN_3_MONTHS}`);
        } else if (monthNum === '6') {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_250_PLAN_6_MONTHS}`);
          setPaystackPlanCode(`${keys.PAYSTACK_250_PLAN_6_MONTHS}`);
        } else {
          setFlutterwavePlanCode(`${keys.FLUTTERWAVE_250_PLAN_1_YEAR}`);
          setPaystackPlanCode(`${keys.PAYSTACK_250_PLAN_1_YEAR}`);
        }
      } else {
        // no recurring
        setAutoDebit(false);
      }
    },
    [monthNum],
  );

  const payWithPaystack = (plan, itemprice) => {
    if (autoDebit && monthNum !== '2')
      return subscribeForRecurringPlanWithPaystack(paystackPlanCode, user);
    return subscribeForPlanWithPaystack(monthNum, plan, user, itemprice);
  };

  const payWithRave = (plan, itemprice) => {
    if (autoDebit && monthNum !== '2')
      return subscribeForRecurringPlanWithFlutterWave(
        flutterwavePlanCode,
        monthNum,
        plan,
        user,
        itemprice
      );
    return subscribeForPlanWithFlutterWave(monthNum, plan, user, itemprice);
  };

  // const payWithSlydePay = (plan) => subscribeForPlanWithSlydePay(plan, user);
  // const payWithTheTeller = (plan) => subscribeForPlanWithTheTeller(plan, user);
  useEffect(() => {
    userPlans.forEach((plan) => {
      setCurrentPlan(plan); // Updates the current plan state
      planChange(plan); // Calls the planChange function
    });
  }, [planChange, userPlans]);

  useEffect(() => {
    // Check if currentPlan.mac_id exists before making the API call
    if (currentPlan?.mac_id) {
      const data = {
        TB_PREF: '2_',
        macid: currentPlan.mac_id,
      };

      const getItemPrice = async (data) => {
        setLoad(true); // Indicate loading state
        try {
          const response = await axios.post(
            `https://api.tizeti.com/api/v1/legacy/getItemPrice`,
            data,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
              },
            },
          );
          if (response?.data) {
            setItemprice(response.data.itemprice); // Update state with the fetched item price
          }
        } catch (e) {
          console.error('Error fetching item price:', e);
        } finally {
          setLoad(false); // Reset loading state
        }
      };

      getItemPrice(data); // Call the API function
    }
  }, [currentPlan]); // Re-run the effect when `currentPlan` changes

  return (
    <div className="text-center">
      <span className="sub_text font_22">Current Plan</span>
      <div className="row justify-content-center align-items-center">
        {isLoading ? (
          <small>loading...</small>
        ) : !isEmpty(currentPlan) ? (
          <div key={currentPlan.id} className="col-md-7 col-xl-5 mb-4">
            <div className="card box shadow h-100 py-2">
              <div className="card-body">
                <div className="row col-auto align-items-center">
                  <div className="col-auto">
                    <div className=" text-center d-flex mb-0">
                      <div>
                        <img
                          src="images/residential.png"
                          alt="House"
                          className="mr-2 mt-3"
                        />
                      </div>
                      <div className="text-left">
                        <div className="font_18 text-wrap bolder_font margin_bottom">
                          {currentPlan.username}
                        </div>
                        <div className="form-group d-flex mb-0 pb-0">
                          <select
                            defaultValue={monthNum}
                            id="monthNum"
                            className="form-control form-control-sm mt-2 mr-3"
                            onChange={(e) => setMonthNum(e.target.value)}
                          >
                            <option value="1">1 Month</option>
                            <option value="2">2 Months</option>
                            <option value="3">3 Months</option>
                            <option value="6">6 Months (+ 1 month free)</option>
                            <option value="12">1 Year (+ 2 months free)</option>
                          </select>
                          <label
                            className="d-flex mt-3 lighter_font"
                            htmlFor="monthNum"
                          >
                            GH₵
                            <span className="ml-1">{monthNum * itemprice}</span>
                          </label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <label
                            htmlFor="autoDebit"
                            className="checkbox-inline mt-0 lighter_font text-nowrap"
                          >
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              checked={autoDebit}
                              id="autoDebit"
                              onChange={(e) => setAutoDebit(e.target.checked)}
                            />
                            <span
                              className={
                                monthNum !== '2' &&
                                currentPlan.monthly_subscription <= 250
                                  ? 'ml-1 custom-control-label'
                                  : 'd-none'
                              }
                            >
                              I want to be charged{' '}
                              {monthNum === '1'
                                ? 'monthly'
                                : monthNum === '3'
                                ? 'quarterly'
                                : monthNum === '6'
                                ? 'bi-annually'
                                : monthNum === '12'
                                ? 'yearly'
                                : null}
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row col-auto justify-content-center align-items-center">
                <div className="col-auto align-items-center py-3 mr-2 d-flex">
                  <div className="payChannel_text text-nowrap m-0 p-0 pr-1 mt-1">
                    Pay with:
                  </div>
                  <div className="btn-group btn-group-sm" role="group">
                    <button
                      className="btn btn-outline-success mr-1"
                      onClick={() => payWithRave(currentPlan, itemprice)}
                    >
                      <img
                        alt="flutterwave logo"
                        src="images/flutterwave.png"
                        width="100px"
                      />
                    </button>
                    <button
                      className="btn btn-outline-success"
                      onClick={() => payWithPaystack(currentPlan, itemprice)}
                    >
                      <img
                        alt="paystack logo"
                        src="images/paystack.png"
                        width="115px"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <ToastContainer />
    </div>
  );
};

UserAccounts.proptype = {
  isLoading: PropTypes.bool,
  userPlans: PropTypes.object,
  user: PropTypes.object,
  loadingSlyde: PropTypes.bool,
  loadingTeller: PropTypes.bool,
};

export default withRouter(UserAccounts);
